import styled from 'styled-components';

const RedirectLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;

  .container {
    max-width: 850px;
    padding: 1em;
    box-sizing: border-box;
  }

  .preview-img {
    max-width: 300px;
    min-height: 30px;
  }

  .text-center {
    text-align: center;
  }

  h1 {
    font-size: 40px;
    margin-top: 0;
  }

  h2 {
    color: #a2a4b2;
    font-style: italic;
  }

  .primary-button {
    text-align: center;
    outline: none;
    border: 0;
    font-size: 1.125rem;
    font-weight: 500;
    cursor: pointer;
    font-family: 'HelveticaNeue', 'Helvetica Neue', 'Helvetica', 'SF Pro Text', 'Arial', sans-serif;
    padding: 7px 1em;
    height: 48px;
    box-sizing: border-box;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.color.primary};
    color: ${(p) => p.theme.color.white};
    transition: opacity 0.25s ease-in-out;
    margin: 1.5em 0 1em;
    text-decoration: none;
    display: inline-block;
    line-height: 1.8em;
  }

  .primary-button:hover {
    opacity: 0.8;
  }
`;

const RedirectToV2Page = () => {
  return (
    <RedirectLayout>
      <div class="container">
        <div class="text-center">
          <img
            class="preview-img"
            alt="AZ Monica"
            src="https://iridiumnetwerk.be/swfiles/files/iridium_contactbeelden_azmonica.jpg"
          />
        </div>

        <h1 class="text-center">Verhuisd - Moved</h1>
        <h2 class="text-center">Deze versie van het patiëntenportaal wordt niet meer gebruikt.</h2>

        <p>
          <b>Nederlands</b> - Het AZ Monica ziekenhuis is overgeschakeld naar een nieuwe versie van het
          patiëntenportaal. Klik op de knop hieronder om het nieuwe portaal te openen.
        </p>
        <p>
          <b>Français</b> - L'hôpital AZ Monica est passé à une nouvelle version du portail pour les patients. Cliquez
          sur le bouton ci-dessous pour accéder au nouveau portail.
        </p>
        <p>
          <b>English</b> - The AZ Monica Hospital has switched to a new version of the patient portal. Click on the
          button below to access the new portal.
        </p>

        <div class="text-center">
          <a class="primary-button" href="https://my.azmonica.be/umbi/patient" target="_self">
            Naar het nieuwe portaal
          </a>
        </div>
      </div>
    </RedirectLayout>
  );
};

export default RedirectToV2Page;
